import { RequestTypes } from '../requestTypes'
import { authKeys } from '..'
import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IMFASession, MFASession } from '@core/entities/auth/MFASession'

interface IMFASessionResponse {
  sessions: IMFASession[]
}

interface MFASessionResponse {
  sessions: MFASession[]
}

export const useGetActiveMFASessions = (
  payload: RequestTypes['getActiveMFASessions'],
  options?: UseQueryOptions<
    IMFASessionResponse,
    RequestErrorType,
    MFASessionResponse
  >,
) => {
  return useQuery({
    ...authKeys.getActiveMFASessions(payload),
    ...options,
    select: (data) => {
      return {
        sessions: data.sessions.map((session) => MFASession.new(session)),
      }
    },
  })
}
